import { useRef } from "react";
import { Scene } from "@/components/site/Illustrations";
import { AssetImage } from "@/components/site/AssetImage";
import { EditableText } from "@/components/site/EditableText";
import { useInView } from "@/lib/useInView";

export function Panels({ items, cols = "sm:grid-cols-2 lg:grid-cols-4", testId, titleSize = "text-xl" }) {
  const ref = useRef(null);
  const inView = useInView(ref);
  return (
    <ol ref={ref} className={`of-panels mt-10 grid gap-5 ${cols} ${inView ? "is-in" : ""}`} data-testid={testId} data-in-view={inView}>
      {items.map((it, i) => (
        <li key={it.asset} className="of-panel of-card overflow-hidden" style={{ "--i": i }} data-testid={it.testId}>
          <Scene asset={it.asset} className="aspect-[16/11] w-full" testId={`${it.testId}-illustration`} />
          <div className="p-6">
            <p className="text-sm font-bold text-[var(--pg-ink)]">Step {i + 1}</p>
            <EditableText k={it.titleKey} def={it.title} as="h3" className={`mt-1 ${titleSize} font-semibold leading-snug`} />
            <EditableText k={it.bodyKey} def={it.body} multiline className="mt-2 leading-relaxed text-[#3B4A44]" />
            {it.photo && <AssetImage asset={it.photo} size="md" sizes="(min-width: 768px) 360px, 100vw" className="mt-5 aspect-[4/3] w-full rounded-2xl" testId={`${it.testId}-photo`} />}
          </div>
        </li>
      ))}
    </ol>
  );
}
